import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, RoundPendingIcon, Text } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';

const HEADER = 'You cannot add your contribution';
const DESCRIPTION = `The payment method you have chosen hasn't been verified yet.
 You will be able to make your contribution as soon as your bank account has been successfully confirmed.`;

interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export const PendingPlaidAccountWarningModal: React.FC<Props> = ({
  visible,
  onSetVisible,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();
  return (
    <ModalWrapper testId="PendingPlaidAccountWarningModal" visible={visible} onSetVisible={onSetVisible}>
      <Box align="center" pad={{ vertical: 'spacing24', horizontal: 'spacing36' }}>
        <RoundPendingIcon color="warning" />
        <Text
          data-testid="PendingPlaidAccountWarningModal_modal_header"
          margin={{ vertical: 'spacing12' }}
          textAlign="center"
          size="24px"
          weight={700}
        >
          {t(HEADER)}
        </Text>

        <Text
          data-testid="PendingPlaidAccountWarningModal_modal_help-text"
          margin={{ bottom: 'spacing24' }}
          textAlign="center"
        >
          {t(DESCRIPTION)}
        </Text>

        <Box direction="row" gap="spacing12">
          <AppButton
            buttonType="secondary"
            testId="PendingPlaidAccountWarningModal_modal_cancel"
            onClick={onCancel}
            width="200px"
          >
            {t('Back to Contributions')}
          </AppButton>
          <AppButton testId="PendingPlaidAccountWarningModal_modal_submit" onClick={onSubmit} width="200px">
            {t('Change Payment Method')}
          </AppButton>
        </Box>
      </Box>
    </ModalWrapper>
  );
};
